<template>
  <!-- 项目进度 -->
  <div class="main">
    <!-- 标题行 -->
    <div class="titleRow">
      <div class="title">
        <el-divider direction="vertical"></el-divider>
        <span class="projectProgress">项目进度</span>
        <span class="prjNameStyle" :title="currentProject.prjName">{{ currentProject.prjName }}</span>
      </div>

      <div class="options">
        <el-select v-model="gap" placeholder="请选择时间间隔" size="mini" @change="timeGapChange">
          <el-option v-for="item in gaps" :key="item.id" :label="item.label" :value="item.id">
          </el-option>
        </el-select>
        <span :class="{'spanDisabled': !currentPrjId}" @click="enterProjectProcess">更多<i
          class="el-icon-d-arrow-right"></i></span>
      </div>
    </div>

    <!-- 甘特图 -->
    <div class="ganteChart">
      <div ref="gantt" class="gantt"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { gantt } from "dhtmlx-gantt";
import "dhtmlx-gantt/codebase/dhtmlxgantt.css";
import workProjectBoardService from "@/CommonDP/service/workProjectBoard-service";
import moment from "moment";

export default {
  components: {},
  props: ["currentPrjId", "currentProject"],
  data() {
    return {
      tasks: {
        data: [],
        links: []
      }, // 甘特图数据
      gaps: [
        { id: 0, label: "一天" },
        { id: 1, label: "两天" },
        { id: 2, label: "一周" },
        { id: 3, label: "一月" }
      ], // 时间间隔
      gap: 2
    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId
    })
  },
  watch: {
    currentPrjId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.initTaskData();
        }
      }
    }
  },
  mounted() {
    this.gantt_init();
    gantt.clearAll();
  },
  methods: {
    // 进入项目任务进度
    enterProjectProcess() {
      this.$emit("enterProjectFront");
      // this.$router.push("/mainMg/projectMg/progress/list");
      this.$router.push("/project-taskList");
    },

    // 甘特图初始化
    gantt_init() {
      gantt.i18n.setLocale("cn"); // 汉化
      gantt.config.show_grid = false; // 是否显示左侧树表格
      gantt.config.row_height = 41; // 设置行高
      gantt.config.task_height = 41;
      gantt.config.scale_height = 50; // 设置时间刻度的高度
      gantt.config.min_column_width = 40; // 设置最小宽度
      gantt.config.xml_date = "%Y-%m-%d"; // 日期格式化
      gantt.config.scales = [
        { unit: "year", step: 1, format: "%Y" },
        { unit: "day", step: 7, format: "%m-%d" }
      ];
      gantt.config.readonly = true; // 只读
      gantt.config.show_links = true; // 是否显示依赖连线
      gantt.templates.task_text = (start, end, task) => {
        const code = gantt.getWBSCode(task);
        return code + ". " + task.taskName;
      }; // 自定义任务名称
      gantt.templates.task_class = function (start, end, task) {
        if (task.coreTask == 2) return "key";
        let taskClass = "without";
        switch (task.taskStatus) {
          case 0:
            taskClass = "without";
            break;
          case 1:
            taskClass = "low";
            break;
          case 2:
            taskClass = "medium";
            break;
          case 3:
            taskClass = "high";
            break;
        }
        return taskClass;
      }; // 自定义task状态对应的样式
      gantt.templates.link_class = function (link) {
        const { type } = link;
        if (type == "1") return "start_start_link";
        else return "end_start_link";
      }; // 自定义link状态对应的样式
      gantt.attachEvent("onTaskDblClick", (id, e) => {
        this.toTaskProgress(id);
        return true;
      }); // 双击事件
      gantt.init(this.$refs.gantt);
    },
    // 跳转到任务详情
    toTaskProgress(id) {
      this.$emit("enterProjectFront");
      this.$router.push({
        // path: "/mainMg/projectMg/progress/checkAddEdit",
        path: "/project-taskDetail",
        query: {
          showType: "check",
          task: id || "0"
        }
      });
    },

    // 任务数据初始
    async initTaskData() {
      const params = {
        prjId: this.currentPrjId,
        labelIds: [],
        isCore: 2,
        enterpriseId: this.enterpriseId
      };
      const res = await workProjectBoardService.queryPlanList(params);
      let { links, list } = res.data;
      links = links || [];
      list = list || [];
      list.forEach(item => {
        item.id = item.taskId;
        item.parent = item.parentId;
        item.start_date = item.startDate;
        item.end_date = this.addOnDay(item.endDate, 1);
        item.open = true;
        item.progress = item.taskProgress / 100;
      });
      this.tasks.data = list;
      this.tasks.links = links;
      gantt.clearAll();
      gantt.parse(this.tasks);
      gantt.scrollTo(0, 0);
    },
    // 格式化
    addOnDay(time, num) {
      return moment(time)
        .add(num, "days")
        .format("YYYY-MM-DD");
    },

    // 更改时间间隔
    timeGapChange() {
      this.configTimeGap();
      gantt.clearAll();
      gantt.parse(this.tasks);
      gantt.scrollTo(0, 0);
    },
    configTimeGap() {
      switch (this.gap) {
        case 0:
          gantt.config.scales = [
            { unit: "year", step: 1, format: "%Y" },
            { unit: "day", step: 1, format: "%m-%d" }
          ];
          break;
        case 1:
          gantt.config.scales = [
            { unit: "year", step: 1, format: "%Y" },
            { unit: "day", step: 2, format: "%m-%d" }
          ];
          break;
        case 2:
          gantt.config.scales = [
            { unit: "year", step: 1, format: "%Y" },
            { unit: "day", step: 7, format: "%m-%d" }
          ];
          break;
        case 3:
          gantt.config.scales = [
            { unit: "year", step: 1, format: "%Y" },
            { unit: "month", step: 1, format: "%m" }
          ];
          break;

        default:
          gantt.config.scales = [
            { unit: "year", step: 1, format: "%Y" },
            { unit: "day", step: 1, format: "%m-%d" }
          ];
          break;
      }
    }
  }
};
</script>

<style lang='scss' scoped>
.main {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .titleRow {
    width: 100%;
    border-bottom: 1px solid #e5e8f1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    .title {
      display: flex;
      align-items: center;
      width: calc(100% - 160px);
      .prjNameStyle {
        max-width: 75%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .projectProgress {
        width: 65px;
        margin-right: 10px;
      }
      .el-divider {
        width: 3px;
        height: 15px;
        margin-left: 0;
        background: var(--theme-color);
      }
      @media (max-width: 1440px) {
        span {
          font-family: "PingFang SC";
          font-weight: 700;
          font-size: 14px;
          color: var(--key-color);
        }
      }
      @media (min-width: 1440px) {
        span {
          font-family: "PingFang SC";
          font-weight: 700;
          font-size: 16px;
          color: var(--key-color);
        }
      }
    }

    .options {
      display: flex;
      align-items: center;
      .el-select {
        width: 100px;
        right: calc(50px + var(--big-space));
        position: absolute;
      }
      @media (max-width: 1440px) {
        span {
          font-family: "PingFang SC";
          font-weight: 400;
          font-size: 12px;
          color: var(--common-color);
          cursor: pointer;
          display: flex;
          align-items: center;
        }
      }
      @media (min-width: 1440px) {
        span {
          font-family: "PingFang SC";
          font-weight: 400;
          font-size: 14px;
          color: var(--common-color);
          cursor: pointer;
          display: flex;
          align-items: center;
        }
      }
      span:hover {
        color: var(--theme-color);
      }

      .spanDisabled {
        pointer-events: none;
      }
    }
  }

  .ganteChart {
    width: 100%;
    height: 1px;
    flex-grow: 1;
    padding: var(--big-space);

    .gantt {
      width: 100%;
      height: 100%;
    }
  }
}

/deep/ .end_start_link {
  .gantt_line_wrapper > * {
    background-color: purple !important;
  }

  .gantt_link_arrow_right {
    border-left-color: purple !important;
  }

  .gantt_link_arrow_left {
    border-left-color: purple !important;
  }
}

/deep/ .start_start_link {
  .gantt_line_wrapper > * {
    background-color: var(--theme-color) !important;
  }

  .gantt_link_arrow_right {
    border-left-color: var(--theme-color) !important;
  }

  .gantt_link_arrow_left {
    border-left-color: var(--theme-color) !important;
  }
}

/deep/ .gantt_layout_root {
  .timeline_cell {
    .gantt_task_line {
      height: 22px !important;
      line-height: 20px !important;
      border-radius: 10px;
      margin-top: 7px;
    }
    .weekend {
      background: #f4f7f4 !important;
    }
    .key {
      background: var(--key-color);
      border-color: var(--key-color);

      .gantt_task_progress {
        background: #292828;
      }
    }
    .without {
      background: #dcdcdc;
      border-color: #dcdcdc;

      .gantt_task_progress {
        background: #b4b3b3;
      }
    }
    .low {
      background: #69e2b3;
      border-color: #69e2b3;

      .gantt_task_progress {
        background: #22ac76;
      }
    }
    .medium {
      background: #a4bafa;
      border-color: #a4bafa;

      .gantt_task_progress {
        background: #4689f6;
      }
    }
    .high {
      background: #fdd2d2;
      border-color: #fdd2d2;

      .gantt_task_progress {
        background: #f75c5c;
      }
    }
  }
}
</style>
